const IS_DEV = process.env.NODE_ENV === "development";
const IS_BROWSER = typeof window !== "undefined";
const GOOGLE_PIXELS = process.env.GOOGLE_PIXELS
    ? process.env.GOOGLE_PIXELS
    : null;

const IS_GOOGLE_PIXEL = !IS_DEV && IS_BROWSER && GOOGLE_PIXELS;

const getPixels = () => {
    let pixels = null;

    if (!IS_GOOGLE_PIXEL) {
        return pixels;
    }

    pixels = [];

    GOOGLE_PIXELS.split(",").forEach((pixel) => pixels.push(pixel.split("/")));

    console("IS_GOOGLE_PIXEL=" + IS_GOOGLE_PIXEL);

    return pixels;
};

export const trackConversion = () => {
    const IS_GOOGLE_TRACK_CONVERSION =
        IS_BROWSER && typeof window.google_trackConversion === "function";

    if (!IS_GOOGLE_PIXEL || !IS_GOOGLE_TRACK_CONVERSION) {
        return;
    }

    const pixels = getPixels();

    for (let i = 0; i < pixels.length; i++) {
        window.google_trackConversion({
            google_conversion_id: pixels[i][0],
            google_conversion_label: pixels[i][1],
        });
    }
};
